import React from 'react';
import { useLocalization } from '@ais-ui/locale-management';

interface NoItemsEmptyStateListProps {
  entity: string;
  srcImage: string;
  children?: React.ReactNode;
}

export const NoItemsEmptyStateList = ({
  entity,
  srcImage,
  children,
}: NoItemsEmptyStateListProps) => {
  const { messages } = useLocalization();
  const message =
    messages.emptyStateNoItems?.replace('{entity}', entity) ??
    `No ${entity} to display`;

  return (
    <div className="flex flex-col w-full h-full justify-center items-center self-center mb-[40%]">
      <img
        className="max-h-96 w-[60%]"
        src={srcImage}
        alt="EmptyList"
        width={400}
        height={400}
        loading="lazy"
      />
      <div className="flex flex-col items-center justify-center my-4 space-y-2 w-[60%]">
        <div className="text-sm text-muted-foreground text-center">
          {message}
        </div>
      </div>
      <div className={'flex w-[60%] justify-center items-center'}>
        {children}
      </div>
    </div>
  );
};

interface NoResultsEmptyStateListProps {
  entity: string;
  srcImage: string;
  children?: React.ReactNode;
}

export const NoResultsEmptyStateList = ({
  entity,
  srcImage,
  children,
}: NoResultsEmptyStateListProps) => {
  const { messages } = useLocalization();
  const message =
    messages.emptyStateNoResults?.replace('{entity}', entity) ??
    `No ${entity} matches your filter`;

  return (
    <div className="flex flex-col w-full h-full justify-center items-center self-center mb-[40%]">
      <img
        className="max-h-96 w-[60%]"
        src={srcImage}
        alt="EmptyList"
        width={400}
        height={400}
        loading="lazy"
      />
      <div className="flex flex-col items-center justify-center my-4 space-y-2 w-[60%]">
        <div className="text-sm text-muted-foreground text-center">
          {message}
        </div>
      </div>
      <div className={'flex w-[60%] justify-center items-center'}>
        {children}
      </div>
    </div>
  );
};
